import Box from "@mui/material/Box";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import LevelLadder from "layouts/your_kitchen/components/LevelLadder";
import TechniqueGrid from "layouts/your_kitchen/components/TechniqueGrid";

/**
 * Your Kitchen — everything the user has actually become, in one place.
 *
 * Both halves used to be invisible. The technique ladder lived on /profile
 * below the password field with no nav entry; testers called it the best thing
 * in the product and only found it by accident. The level number lived on the
 * dashboard pointing at nothing. They belong together and they belong in the
 * nav, directly under Dashboard.
 *
 * Order is deliberate: the level ladder first because it answers "where am I
 * and what's next" in one glance, then the technique grid, which is the slower,
 * richer read. Each card fetches its own data and renders nothing on failure,
 * so neither half can take the other down.
 */
function YourKitchen() {
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ pt: 3, pb: 6, px: { xs: 2, md: 3 }, display: "flex", justifyContent: "center" }}>
        <Box sx={{ width: "100%", maxWidth: 560 }}>
          {/* Title only. The paragraph that used to sit here described the two
              cards underneath it — a skim-reading tester read the description
              and not the ladder or the badges it was describing. */}
          <Box
            sx={{
              fontSize: 22,
              fontWeight: 800,
              color: "#222",
              mb: 3,
              fontFamily: "Roboto, sans-serif",
            }}
          >
            Your Kitchen
          </Box>

          <LevelLadder />
          <TechniqueGrid />
        </Box>
      </Box>
    </DashboardLayout>
  );
}

export default YourKitchen;
